import { render } from "./Hierarquia.vue?vue&type=template&id=1959af34&scoped=true"
import script from "./Hierarquia.vue?vue&type=script&lang=js"
export * from "./Hierarquia.vue?vue&type=script&lang=js"

import "./Hierarquia.vue?vue&type=style&index=0&id=1959af34&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1959af34"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput,QBtn});
